import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPagseguroComponent } from './simple-icons-pagseguro.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPagseguroComponent ],
    exports:      [ SimpleIconsPagseguroComponent ],
    bootstrap:    []
})
export class SimpleIconsPagseguroModule {}
